import { Component, OnInit, Input } from '@angular/core';
import { Ost } from '../../core';
import { WgisService } from 'src/app/wgis/wgis.service';

@Component({
  selector: 'app-ost-result-list',
  templateUrl: './ost-result-list.component.html'
})
export class OstResultListComponent implements OnInit {

  constructor(
    private wgis: WgisService,
  ) { }

  @Input() osts: Ost[] = [];

  ngOnInit() {
    window.scrollTo(0, 0)
  }

  zoomOn(ost: Ost){
    this.wgis.showOstByObj(ost);
  }
}
